import React from 'react';
import { motion } from 'framer-motion';
import { GiWeightLiftingUp } from 'react-icons/gi';
import { FaFlask, FaMobileAlt, FaDumbbell, FaAward, FaDna } from 'react-icons/fa';
import { withTranslation } from 'react-i18next';

class Expertise extends React.Component {
  render() {
    const { t } = this.props
    return (
      <section className="py-16 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            {t("why_diego_trainer_gets_results")}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <FaAward className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">{t("12_years_elite_optimization")}</h3>
              <p className="text-gray-600">
                {t("12_years_elite_optimization_text")}
              </p>
            </motion.div>

            {/* Card 2 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <FaDna className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">{t("data_driven_protocols")}</h3>
              <p className="text-gray-600">
                {t("data_driven_protocols_text")}
              </p>
            </motion.div>

            {/* Card 3 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <FaMobileAlt className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">{t("your_plan_your_phone")}</h3>
              <p className="text-gray-600">
                {t("your_plan_your_phone_text")}
              </p>
            </motion.div>
          </div>

          {/* Added CTA Button */}
          <motion.div 
            className="flex justify-center items-center text-center mt-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.a
              href='#pricing'
              // href="https://training-app.short.gy/train-with-diego-trainer"
              // target="_blank"
              // rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 px-12 rounded-lg flex items-center gap-3 text-lg"
            >
              <FaDumbbell className="text-xl" />
              {t("start_your_transformation_now")}
            </motion.a>
          </motion.div>
        </div>
      </section>
    );
  }
}

export default withTranslation()(Expertise);